export type SaleType = 
  | 'estate_sale' 
  | 'garage_sale' 
  | 'moving_sale' 
  | 'multi_family' 
  | 'fundraiser'
  | 'yard_sale';

export interface SalePhoto {
  id?: string;
  sale_id?: string;
  photo_url: string;
  display_order: number;
  created_at?: string;
}

export interface Sale {
  id: string;
  source_url: string;
  source_website: string;
  title: string;
  description: string | null;
  address: string | null;
  city: string;
  state: string;
  zip_code: string | null;
  timezone: string;
  location: string | null;
  start_date: string;
  end_date: string;
  start_time: string | null;
  end_time: string | null;
  is_archived: boolean;
  created_at: string;
  updated_at: string;
  sale_photos?: SalePhoto[];
}

export interface User {
  id: string;
  email: string;
  full_name?: string;
  avatar_url?: string;
  created_at: string;
}

export interface AuthUser {
  id: string;
  email: string;
  full_name?: string;
  avatar_url?: string;
  selected_city?: string;
}

export type SourceWebsite = 'gsalr.com' | 'estatesales.net' | 'yardsalesearch.com' | 'yardsales.net' | 'garagesalefinder.com' | 'all';

export const SOURCE_WEBSITES: SourceWebsite[] = [
  'gsalr.com',
  'estatesales.net',
  'yardsalesearch.com',
  'yardsales.net',
  'garagesalefinder.com',
];

export const SOURCE_WEBSITE_LABELS: Record<string, string> = {
  'gsalr.com': 'GSALR',
  'estatesales.net': 'EstateSales',
  'yardsalesearch.com': 'YardSaleSearch',
  'yardsales.net': 'YardSales.net',
  'garagesalefinder.com': 'GarageSaleFinder',
};

export const SOURCE_WEBSITE_COLORS: Record<string, string> = {
  'gsalr.com': '#FF6B35',
  'estatesales.net': '#8B5CF6',
  'yardsalesearch.com': '#06B6D4',
  'yardsales.net': '#10B981',
  'garagesalefinder.com': '#F59E0B',
};

export interface FilterState {
  saleType: SaleType | 'all';
  dateRange: 'all' | 'this_weekend' | 'this_week' | 'upcoming';
  priceRange: [number, number] | null;
  sourceWebsite: SourceWebsite | 'all';
}

export interface SearchFilters extends FilterState {
  query: string;
  city: string;
  sortBy: 'date' | 'distance' | 'relevance';
}

export interface MapBounds {
  north: number;
  south: number;
  east: number;
  west: number;
}

export interface Coordinates {
  lat: number;
  lng: number;
}

export const MVP_CITIES = ['Los Angeles', 'Portland', 'Dallas', 'Tampa'] as const;

export type MvpCity = typeof MVP_CITIES[number];

export const CITY_COORDINATES: Record<MvpCity, Coordinates> = {
  'Los Angeles': { lat: 34.0522, lng: -118.2437 },
  'Portland': { lat: 45.5152, lng: -122.6784 },
  'Dallas': { lat: 32.7767, lng: -96.7970 },
  'Tampa': { lat: 27.9506, lng: -82.4572 },
};

export const SALE_TYPE_LABELS: Record<SaleType, string> = {
  estate_sale: 'Estate Sale',
  garage_sale: 'Garage Sale',
  moving_sale: 'Moving Sale',
  multi_family: 'Multi-Family',
  fundraiser: 'Fundraiser',
  yard_sale: 'Yard Sale',
};

export const SALE_TYPE_COLORS: Record<SaleType, string> = {
  estate_sale: '#8B5CF6', // Purple
  garage_sale: '#15803d', // Green
  moving_sale: '#10B981', // Emerald
  multi_family: '#3B82F6', // Blue
  fundraiser: '#F59E0B', // Amber
  yard_sale: '#15803d', // Green
};
